import React from 'react';

import { TranslateFunction } from 'react-localize-redux';

import {
  Card as CardIcon,
  PaymentApplePay as PaymentApplePayIcon,
  PaymentBancontact as PaymentBancontactIcon,
  PaymentCash as PaymentCashIcon,
  PaymentGoogleMicrosoft as PaymentGoogleMicrosoftIcon,
  PaymentIdeal as PaymentIdealIcon,
  PaymentPaypal as PaymentPayPalIcon,
} from '../../../../../components/icons';
import { basketSelectors } from '../../../../../weborder/redux';

const getPayButtonText = (
  selectedPayment: ReturnType<
    typeof basketSelectors.getSelectedPaymentOrDefault
  >,
  translate: TranslateFunction,
): string => {
  if (selectedPayment) {
    switch (selectedPayment.PaymentAccountType) {
      case 'BrainTreePayPalPaymentAccount': {
        if (selectedPayment.paymentId === 'paypal') {
          return `${translate('Add_paypal_account_and_pay')}`;
        }
        return selectedPayment.Description;
      }

      case 'CashPaymentAccount':
        return translate('Checkout_PaymentMethod_PayWithCash') as string;

      case 'CardPaymentAccount': {
        if (selectedPayment.paymentId === 'new_card') {
          return `${translate('Add_card_and_pay')}`;
        }

        const cardNumber =
          selectedPayment.Description.slice(
            selectedPayment.Description.indexOf('*'),
          ) || '';

        return `${translate('Checkout_PaymentMethod_PayWithCard', {
          cardNumber,
        })}`;
      }

      case 'StripePayButtonPaymentAccount':
        if (selectedPayment.Description === 'Apple_pay') {
          return `${translate('Pay_with_apple_pay')}`;
        }
        return `${translate('Google_microsoft_pay')}`;

      case 'PayGreenRestaurantVoucher':
        return `${translate(
          'Checkout_PaymentMethod_payWithRestaurantVoucher',
        )}`;

      default:
        return `${translate('Pay_with')} ${translate(
          selectedPayment.Description,
          undefined,
          {
            missingTranslationMsg: selectedPayment.Description,
          },
        )}`;
    }
  }

  return `${translate('Place_order')}`;
};

const getPaymentOptionsDetails = (payment, translate) => {
  let text: string = payment.Description;
  let icon: React.ReactNode = null;
  let fdKey = `${payment.PaymentAccountType}-option`;

  switch (payment.PaymentAccountType) {
    case 'Bancontact': {
      icon = <PaymentBancontactIcon />;
      text = payment.Description;
      break;
    }

    case 'BrainTreePayPalPaymentAccount': {
      icon = <PaymentPayPalIcon />;

      if (payment.paymentId === 'paypal') {
        text = translate('New_paypal_account') as string;
      } else {
        const paypalLabel = payment.Description.slice(
          payment.Description.indexOf(' '),
        ).trim();
        text = `PayPal (${paypalLabel})`;
      }
      break;
    }

    case 'CardPaymentAccount': {
      icon = <CardIcon />;

      if (payment.paymentId === 'new_card') {
        text = translate('Add_card') as string;
        fdKey = 'add-card-option';
      } else {
        const cardNumber = payment.Description.slice(
          payment.Description.indexOf('*'),
        );
        text = `${translate('Pay_with')} ${translate('Card')} ${cardNumber ||
          ''}`;
      }
      break;
    }

    case 'CashPaymentAccount': {
      text = translate('Cash_wo') as string;
      icon = <PaymentCashIcon />;
      break;
    }

    case 'Ideal': {
      text = payment.Description;
      icon = <PaymentIdealIcon />;
      break;
    }

    case 'StripePayButtonPaymentAccount': {
      text = translate(payment.Description);

      if (payment.Description === 'Apple_pay') {
        icon = <PaymentApplePayIcon />;
      } else {
        icon = <PaymentGoogleMicrosoftIcon />;
      }
      break;
    }

    default:
      text = translate(payment.Description, undefined, {
        missingTranslationMsg: payment.Description,
      });
      break;
  }

  return { fdKey, icon, text };
};

export const paymentOptionsUtils = {
  getPayButtonText,
  getPaymentOptionsDetails,
};
